import React, {useState} from 'react';

import {FieldProp} from '../../../types';
import {DisplayOnly} from '../DisplayOnly';
import {Etl} from '../../../_services/Etl';
import {applyFillMap} from '../../../_helpers/etl';

type LegacySalesOrderTextProps = FieldProp & {};

export const LegacySalesOrderText: React.FunctionComponent<LegacySalesOrderTextProps> = ({
                                                                                             field,
                                                                                             fieldState,
                                                                                             type,
                                                                                             value,
                                                                                             displayOnly,
                                                                                             onChange,
                                                                                             onBlur,
                                                                                   }): JSX.Element => {

    const [isWorking, setIsWorking] = useState<boolean>(false);
    const [legacySalesOrder, setLegacySalesOrder] = useState<any>({});
    const [looksLikeLegacySalesOrder, setLooksLikeLegacySalesOrder] = useState<boolean>(false);

    const legacySystemLabel = field?.flowCustomDisplayComponentConfig?.legacySystemLabel || '';
    const legacySystemRegex = field?.flowCustomDisplayComponentConfig?.legacySystemRegex || '^0*3';

    const {
        touched,
        pristine,
        validating,
        valid,
        invalid,
        errors,
    } = fieldState;

    const classNames = [
        'form-control',
        touched && 'is-touched',
        pristine && 'is-pristine',
        validating && 'is-validating',
        valid && 'is-valid',
        invalid && 'is-invalid',
    ]
        .filter(Boolean)
        .join(' ');

    const containerClassNames = [
        'input-group',
        'activity-group',
        isWorking && 'is-working'
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <div>
            {displayOnly ? <DisplayOnly>{value}</DisplayOnly> :
                <div className={containerClassNames}>
                    <input
                        id={field.htmlId}
                        type={type || 'text'}
                        required={field.isRequired}
                        readOnly={field.gwreadonly_enable}
                        className={classNames}
                        placeholder={field.placeholder}
                        onBlur={(e) => {
                            const v = e.target.value;
                            setLooksLikeLegacySalesOrder(false);

                            if (v) {
                                setIsWorking(true);

                                const re = new RegExp(legacySystemRegex);
                                console.log('making regex from', legacySystemRegex, re, v);
                                if (re.test(v)) {
                                    console.log('regex match');
                                    setLooksLikeLegacySalesOrder(true);
                                }

                                Etl.getInstance().process('torque-legacy-salesorder-autocompleter', {q: value})
                                    .then((response) => {
                                        if (response.ok) {
                                            let result: object | object[] = response.json.result;
                                            if (result instanceof Array) {
                                                result = result.length > 0 ? result[0] : {};
                                            }
                                            console.log('setting legacy salesorder', result);
                                            setLegacySalesOrder(result || {});
                                            if (legacySalesOrder?.salesOrderNumber && legacySalesOrder.salesOrderNumber !== legacySalesOrder?.legacySalesOrderNumber) {
                                                setLooksLikeLegacySalesOrder(true);
                                            }
                                        } else {

                                        }
                                        setIsWorking(false);
                                    })
                                    .catch((error: any) => {
                                        console.log('Error in ETL', error);
                                        setIsWorking(false);
                                    });
                            }

                            onBlur && onBlur();
                        }}
                        onKeyDown={() => {
                            setLegacySalesOrder({});
                            setLooksLikeLegacySalesOrder(false);
                        }}
                        onChange={(e) => {
                            onChange(e.target.value);
                        }}
                        value={value || ''}
                    />
                    {isWorking &&
                        <div className="input-group-append">
                            <span className="input-group-text">
                            <i className="fas fa-spinner fa-spin"></i>
                            </span>
                        </div>
                    }
                </div>
            }

            {(legacySalesOrder?.salesOrderNumber && legacySalesOrder.salesOrderNumber !== legacySalesOrder?.legacySalesOrderNumber) ?
                <div className="d-flex">
                    <div className="flex-grow-1">
                        <div className="invalid-feedback">
                            <small className="d-block">It appears you have entered a Sales Order# from a Legacy System {legacySystemLabel && `(${legacySystemLabel})`}. </small>
                            <small className="d-block">
                                You can replace the Legacy Sales Order# with the Torque Sales Order# {legacySalesOrder.salesOrderNumber} by
                                clicking <button type="button"
                                                 className="btn btn-link p-0"
                                                 onClick={() => {
                                                     onChange(legacySalesOrder.salesOrderNumber);
                                                     setLegacySalesOrder({});
                                                     setLooksLikeLegacySalesOrder(false);
                                                 }}
                            >here</button>
                            </small>
                        </div>
                    </div>
                </div>
                :
                <>
                    {looksLikeLegacySalesOrder &&
                        <div className="d-flex">
                            <div className="flex-grow-1">
                                <div className="invalid-feedback">
                                    <small className="d-block">It appears you have entered a Sales Order# from a Legacy System {legacySystemLabel && `(${legacySystemLabel})`}. </small>
                                    <small className="d-block">We were not able to find the corresponding SAP Sales Order#. Consider putting the Legacy Sales Order# and Invoice# in the <strong>Reason for Credit</strong> field for the customer's reference</small>
                                </div>
                            </div>
                        </div>
                    }
                </>
            }

            <div className="d-flex">
                <div className="flex-grow-1">
                    {errors && errors.map((error: string, index: number) => (
                        <div key={index} className="invalid-feedback">
                            {error}
                        </div>
                    ))}
                </div>

                {!displayOnly && field.maxLength &&
                    <div className="text-right" style={{whiteSpace: 'nowrap'}}>
                        <span className="small text-muted">{value ? value.length : 0} of {field.maxLength}</span>
                    </div>
                }
            </div>
        </div>
    );
}